<template>
  <div>
    <div v-for="question in step.questions" :key="question.id" class="mb-1">
      <div>
        <b> {{ question.text }}</b>
      </div>
      <div v-if="question.answer" class="whitespace-pre-wrap">{{ question.answer }}</div>
      <div v-else><i>No comment</i></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["step", "meetingInstance"],
};
</script>

